

























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class FeatureBadge extends Vue {
    // Member
        
    // Properties
    @Prop({ required: true, type: Boolean })
    public hasFeature!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public requiredLogin!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public small!: boolean;

    // Lifecycle Methods:

    // Methods:
}
